import { Box } from '@chakra-ui/react'
import type { InsuranceParamsDto } from 'BrokerTsLib/src/dtos'
import { useSearchParams } from 'react-router'

import { Loading } from '@/components/Loading'
import { Steps } from '@/components/Steps/Steps'
import { Step1 } from '@/containers/steps/vehicle/Step1'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { SidebarProvider } from '@/context/SidebarContext'
import { StepsProvider } from '@/context/StepsContext'
import { WithAuth } from '@/hoc/WithAuth'
import { PageWrapper } from '@/layouts/components/PageWrapper'
import { Sidebar } from '@/layouts/components/Sidebar'

import PoleasImportSummary from './PoleasImportSummary'

const Step1PageComponent = () => {
  const { insuranceParams: ip, insuranceParamsId: paramsId, isLoadingData } = useInsuranceParams()
  const insuranceParams = ip as InsuranceParamsDto
  const [searchParams] = useSearchParams()
  const typeStr = searchParams.get('type')
  const type = typeStr ? parseInt(typeStr) : undefined

  return (
    <StepsProvider currentStepId={1}>
      <SidebarProvider>
        <PageWrapper
          steps={<Steps />}
          sidebar={<Sidebar />}
          contentHeader={<PoleasImportSummary />}
        >
          <Box sx={{ pt: { base: 0, md: 8 } }}>
            {isLoadingData && <Loading large={true} />}

            {(!paramsId || insuranceParams) &&
              <Step1
                // onSubmit={handleSubmit}
                type={type ?? insuranceParams?.generalParams?.paramsTypeId}
                data={insuranceParams} />
            }
          </Box>
        </PageWrapper>
      </SidebarProvider>
    </StepsProvider>
  )
}

export const Step1Page = WithAuth(Step1PageComponent)